import qs from 'qs';

import { AbstractService } from 'src/services/AbstractService';
import { config } from 'src/lib/config';
import { ServiceError } from 'src/lib/errors';

class ContentStoreEntityProductSpecificationsApi extends AbstractService implements Services.ContentStoreApi.EntityProductSpecifications {
    public async getEntityProductSpecifications(
        bearerToken: string | undefined | false,
        entityId: string,
        productId: string,
        signal?: AbortSignal,
    ): Promise<Models.V3.PageResult<Models.ContentStoreApi.V3.ProductSpecification>> {
        if (!bearerToken) {
            throw new ServiceError({
                message: 'Unable to perform request getEntityProductSpecifications. No bearerToken provided.',
            });
        }

        const url = `api/${this.version}/entities/${entityId}/products/${productId}`;
        const searchParams = qs.stringify({
            requestor: config.appName,
        });

        try {
            const json = await this.api
                .get(url, {
                    signal,
                    searchParams,
                    headers: {
                        Authorization: `Bearer ${bearerToken}`,
                    },
                })
                .json<Models.V3.PageResult<Models.ContentStoreApi.V3.ProductSpecification>>();

            return json;
        } catch (e) {
            throw new ServiceError({
                ...(e as Error),
                message: 'Failed to fetch Entity Product Specification',
                info: (e as Error).message,
                url,
                searchParams,
            });
        }
    }
}

export const ContentStoreEntityProductSpecificationsService = new ContentStoreEntityProductSpecificationsApi(config.services.contentStoreApi);
